import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../../context/AuthContext';
import logoimage from '../../static/CineChain.png';
import PushNotification from '../PushNotification'; // PushNotification 컴포넌트 가져오기

// FontAwesome 관련 import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt, faUserPlus, faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons';

// Logo and Header Styling
export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
`;

export const LogoImage = styled.img`
  width: 180px;
  height: auto;
`;

const HeaderContainer = styled.header`
  display: flex;
  width: 100%;
  background-color: #fff;
  justify-content: center;
`;

const HeaderContents = styled.header`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width:1440px;
  background-color: #fff;
`;

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 30px;
  background-color: #f9f9f9;
  border-bottom: 2px solid #e5e5e5;
`;

const AuthLinks = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const AuthLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px; /* 아이콘과 텍스트 사이 간격 */
  text-decoration: none;
  color: #666;
  font-weight: bold;
  padding: 10px;

  &:hover {
    color: #6a1b9a;
  }
`;

const NoticeSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 40px;
  background-color: #f1f1f1;
`;

const NoticeWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const NoticeMore = styled(Link)`
  margin-left: 10px;
  font-size: 14px;
  color: #6a1b9a;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
const TimeWrapper = styled.div`
  font-size: 14px;
  color: #666;
`;

const Header = ({ notices }) => {
  const { isLoggedIn, logout, user } = useAuth();
  const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
  const [currentNoticeIndex, setCurrentNoticeIndex] = useState(0);
  const navigate = useNavigate();  // useNavigate 훅 사용

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);
    
    return () => clearInterval(timer); // Cleanup the interval on component unmount
  }, []);

  useEffect(() => {
    if (notices && notices.length > 0) {
      const interval = setInterval(() => {
        setCurrentNoticeIndex((prevIndex) => (prevIndex + 1) % notices.length);
        //console.log('현재 데이터 '+ notices[currentNoticeIndex].line_text);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [notices]);

  const handleLogout = () => {
    logout();  // 로그아웃 함수 호출
    navigate('/');  // 로그아웃 후 홈페이지로 리다이렉트
  };

  return (
    <HeaderContainer>
      <HeaderContents>
        <TopBar>
          <LogoContainer to="/">
            <LogoImage src={logoimage} alt="Company Logo" />
          </LogoContainer>
          <AuthLinks>
            {isLoggedIn ? (
              <>
                <PushNotification userId={user.id} /> {/* 알림 구독 컴포넌트 추가 */}
                {user && <span>{user.name}님 환영합니다</span>}
                <AuthLink to="/Settings/MyPage">
                  <FontAwesomeIcon icon={faUser} /> 마이페이지
                </AuthLink>
                <AuthLink to="#" onClick={handleLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} /> 로그아웃
                </AuthLink>
              </>
            ) : (
              <>
                <AuthLink to="/Login">
                  <FontAwesomeIcon icon={faSignInAlt} /> 로그인
                </AuthLink>
                <AuthLink to="/register">
                  <FontAwesomeIcon icon={faUserPlus} /> 회원가입
                </AuthLink>
              </>
            )}
          </AuthLinks>
        </TopBar>
        <NoticeSection>
          <NoticeWrapper>
            {notices && notices.length > 0 ? (
              <>
                <span>{notices[currentNoticeIndex].line_text}</span>
                <NoticeMore to="/CSCenter/Notices">more</NoticeMore>
              </>
            ) : (
              <span>공지사항이 없습니다.</span>
            )}
          </NoticeWrapper>
          <TimeWrapper>현재시간 : {currentTime}</TimeWrapper>
        </NoticeSection>
      </HeaderContents>
    </HeaderContainer>
  );
};

export default Header;
